import React from 'react';

const Footer = () => {
    return (
        <footer className="flex flex-col gap-2 sm:flex-row py-6 w-full shrink-0 items-center px-4 md:px-6 border-t border-zinc-800 bg-black">
            <p className="text-xs text-zinc-400">&copy; 2025 cloudtal. Alle Rechte vorbehalten.</p>
            <nav className="sm:ml-auto flex gap-4 sm:gap-6">
                <a
                    className="text-xs text-zinc-400 hover:text-zinc-300 hover:underline underline-offset-4 transition-colors"
                    href="/impressum"
                >
                    Impressum
                </a>
                <a
                    className="text-xs text-zinc-400 hover:text-zinc-300 hover:underline underline-offset-4 transition-colors"
                    href="/datenschutz"
                >
                    Datenschutz
                </a>
            </nav>
        </footer>
    );
};

export default Footer;
